import React, { useEffect, useState } from 'react';
import { TOKEN_NAME } from '@app/constants/global.const';
import './index.scss';

const REDIRECT_SECONDS = 10;

const SessionExpiredPage = () => {
    const [countdown, setCountdown] = useState(REDIRECT_SECONDS);

    // Xóa token ngay khi vào trang
    useEffect(() => {
        localStorage.removeItem(TOKEN_NAME);
    }, []);

    // Countdown redirect về trang login
    useEffect(() => {
        if (countdown <= 0) {
            window.location.href = '/login';
            return;
        }
        const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown]);

    const handleLoginNow = () => {
        window.location.href = '/login';
    };

    return (
        <div className="session-expired">
            <div className="session-expired__backdrop" />
            <div className="session-expired__card">
                {/* Icon */}
                <div className="session-expired__icon">
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M12 7v5l3 3"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M4 4l16 16"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>

                {/* Content */}
                <h1 className="session-expired__title">
                    Phiên đăng nhập hết hạn
                </h1>
                <p className="session-expired__desc">
                    Phiên làm việc của bạn đã hết hạn.
                    <br />
                    Vui lòng đăng nhập lại để tiếp tục sử dụng hệ thống.
                </p>

                {/* Countdown */}
                <div className="session-expired__countdown">
                    Tự động chuyển về trang đăng nhập sau{' '}
                    <span className="session-expired__countdown-number">
                        {countdown}s
                    </span>
                </div>

                {/* Button */}
                <button
                    type="button"
                    className="session-expired__btn"
                    onClick={handleLoginNow}
                >
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    Đăng nhập lại
                </button>

                {/* Progress bar */}
                <div className="session-expired__progress-track">
                    <div
                        className="session-expired__progress-bar"
                        style={{
                            width: `${((REDIRECT_SECONDS - countdown) / REDIRECT_SECONDS) * 100}%`,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredPage;
